import { LinkAppearance as FluentLinkAppearance, LinkTarget as FluentLinkTarget, AnchorTarget as FluentAnchorTarget } from "@fluentui/web-components";
/** Appearance values for {@link Link}. */
export const LinkAppearances = {
    ...FluentLinkAppearance
};
export const LinkAppearance = LinkAppearances;
/** Target values for {@link Link}. */
export const LinkTargets = { ...FluentLinkTarget };
export const LinkTarget = LinkTargets;
/** Anchor target values exposed for downstream consumers. */
export const AnchorTargets = { ...FluentAnchorTarget };
export const AnchorTarget = AnchorTargets;
//# sourceMappingURL=link.options.js.map